/* eslint-disable */
import { phoneTypes } from '@ringcentral-integration/commons/enums/phoneTypes';
export default {
  [phoneTypes.business]: 'Teléfono del trabajo',
  [phoneTypes.extension]: 'Número de extensión',
  [phoneTypes.home]: 'Número particular',
  [phoneTypes.mobile]: 'Teléfono móvil',
  [phoneTypes.phone]: 'Teléfono',
  [phoneTypes.unknown]: 'Tipo de teléfono desconocido',
  [phoneTypes.company]: 'Número de la empresa',
  [phoneTypes.direct]: 'Número directo',
  [phoneTypes.contact]: 'Teléfono de contacto',
  [phoneTypes.fax]: 'Fax',
  [phoneTypes.other]: 'Otro',
};

// @key: @#@"[phoneTypes.business]"@#@ @source: @#@"Business Phone"@#@
// @key: @#@"[phoneTypes.extension]"@#@ @source: @#@"Extension Number"@#@
// @key: @#@"[phoneTypes.home]"@#@ @source: @#@"Home Number"@#@
// @key: @#@"[phoneTypes.mobile]"@#@ @source: @#@"Mobile Phone"@#@
// @key: @#@"[phoneTypes.phone]"@#@ @source: @#@"Phone"@#@
// @key: @#@"[phoneTypes.unknown]"@#@ @source: @#@"Unknown Phone Type"@#@
// @key: @#@"[phoneTypes.company]"@#@ @source: @#@"Company Number"@#@
// @key: @#@"[phoneTypes.direct]"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"[phoneTypes.contact]"@#@ @source: @#@"Contact Phone"@#@
// @key: @#@"[phoneTypes.fax]"@#@ @source: @#@"Fax"@#@
// @key: @#@"[phoneTypes.other]"@#@ @source: @#@"Other"@#@
